class HHCollectionHeaderCarousel extends HTMLElement {
  constructor() {
    super()

    this.mainGallery = null
    this.sectionId = this.getAttribute('data-section-id')
    this.swiperSelector = `[data-section-id='${this.sectionId}'] .swiper`
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.mainGallery = new Swiper(this.swiperSelector, {
      spaceBetween: 5,
      slidesPerView: 'auto',
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      breakpoints: {
        990: {
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
        },
      },
    })
  }
}

customElements.define(
  'hh-collection-header-carousel',
  HHCollectionHeaderCarousel
)
